<template>
  <BasePopup ref="popup" title="Delete Highlight">
    <p>Are you sure you want to delete this highlight?</p>
    <template #buttons>
      <AppButton :outlined="true" :big="true" @click="hide">Cancel</AppButton>
      <AppButton :danger="true" :big="true" @click="confirmDeletion">
        Delete
      </AppButton>
    </template>
  </BasePopup>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import type { AnnotationView } from '@/models/doc'

import BasePopup from '@/components/ui/BasePopup.vue'
import AppButton from '@/app/components/button/AppButton.vue'

const emit = defineEmits<{
  (e: 'confirmDelete', value: AnnotationView): void
}>()

const popup = ref<InstanceType<typeof BasePopup> | null>(null)

const highlight = ref<AnnotationView | undefined>(undefined)

function show(_highlight: AnnotationView): void {
  highlight.value = _highlight
  popup.value?.show()
}

function hide(): void {
  popup.value?.hide()
}

function confirmDeletion(): void {
  emit('confirmDelete', highlight.value as AnnotationView)
  hide()
}

defineExpose({
  show,
  hide,
})
</script>
